export function navbarController($rootScope, $scope, $window, $uibModal,
    BreedListService, DisorderDataService, EntryIDService, NavigationService, ImageService, TranslationService, UtilityService,
    reportdata) {
    'ngInject';

    let resultString = reportdata.resultString;
    let sampleDetails = reportdata.sampleDetails;
    let reportDetails = reportdata.reportDetails;
    let lastSlash = window.location.pathname.lastIndexOf("/");
    
    var token = window.location.pathname.substring(lastSlash + 1, window.location.pathname.length );
    
    ImageService.getImageUrl('2wmltkOoi4woMqyqeC246q').then(function(response) {
        $scope.downloadImageUrl = response.data.fields.file.url;
    });
    ImageService.getImageUrl('hF9D8w0GkwekaaGiWiUoa').then(function(response) {
        $scope.wisdomPanelLogoUrl = response.data.fields.file.url;
    });
    // upgrade modal
    $scope.open = function () {
        var modalInstance = $uibModal.open({
            template: require('../partials/upgrademodal.html'),
            controller: 'UpgradeModalController'
        });
    }
    
    $scope.reportToken = token;
    $scope.translation = TranslationService.getTranslation;
    $scope.getVersionFeature = UtilityService.getVersionFeature;
    $scope.productVersion = UtilityService.getProductVersion();
    $scope.breedList = BreedListService.getSortedBreedList();
    $scope.ancestryEntryID = EntryIDService.getEntryID('Ancestry');
    $scope.ancestrytreeEntryID = EntryIDService.getEntryID('Ancestry Tree');
    $scope.breedtestsEntryID = EntryIDService.getEntryID('Breed Tests');
    $scope.breedsEntryID = EntryIDService.getEntryID('Breeds');
    $scope.breedsanalyzedEntryID = EntryIDService.getEntryID('Breeds Analyzed');
    $scope.certificateEntryID = EntryIDService.getEntryID('Certificate');
    $scope.healthEntryID = EntryIDService.getEntryID('Health');
    $scope.multidrugsensitivityEntryID = EntryIDService.getEntryID('Multidrug Sensitivity');
    $scope.traitsEntryID = EntryIDService.getEntryID('Traits');
    $scope.eicEntryID = EntryIDService.getEntryID('Exercise Induced Collapse');
    $scope.adultweightEntryID = EntryIDService.getEntryID('Adult Weight');
    $scope.atRiskEntryID = EntryIDService.getEntryID('At Risk');
    $scope.carrierEntryID = EntryIDService.getEntryID('Carrier');
    $scope.allClearEntryID = EntryIDService.getEntryID('All Clear');
    $scope.noCallEntryID = EntryIDService.getEntryID('No Call');
    $scope.communityEntryID = EntryIDService.getEntryID('Community');
    $scope.learnMoreEntryID = EntryIDService.getEntryID('Learn More');
    $scope.theScienceEntryID = EntryIDService.getEntryID('The Science');
    $scope.faqsEntryID = EntryIDService.getEntryID('FAQs');
    $scope.ourTechnologyEntryID = EntryIDService.getEntryID('Our Technology');
    $scope.inheritanceEntryID = EntryIDService.getEntryID('Inheritance');
    $scope.learnmoreTraitsEntryID = EntryIDService.getEntryID('LearnMoreTraits');
    $scope.glossaryEntryID = EntryIDService.getEntryID('Glossary');
    $scope.notesEntryID = EntryIDService.getEntryID('Notes');
    $scope.breedTests = resultString.resultPbDd !== undefined && resultString.resultPbDd.length > 0;
    $scope.sampleID = resultString.sampleID;
    $scope.allowUpgrade = sampleDetails.upgrade;
    console.log('allowUpgrade: ' + $scope.allowUpgrade + ' ' + sampleDetails.upgrade);

    $scope.atRiskData = DisorderDataService.getAtRiskData();
    $scope.carrierData = DisorderDataService.getCarrierData();
    $scope.noCallData = DisorderDataService.getNoCallData();
    $scope.allClearData = DisorderDataService.getAllClearData();

    var notifyCount = 0;
    var genHealthCount = 0;
    var letterCheck = false;
    var genHealthCheck = false;
    var decodedCookie = decodeURIComponent(document.cookie);
    var cookies = decodedCookie.split(';');

    for (var i = 0; i < cookies.length; i++) {
        var cookieAttr = cookies[i];
        if (cookieAttr.indexOf('letterCheck') > -1) {
        	letterCheck = cookieAttr.substr(cookieAttr.indexOf("=") + 1);
        }
        if (cookieAttr.indexOf('genHealthCheck') > -1) {
        	genHealthCheck = cookieAttr.substr(cookieAttr.indexOf("=") + 1);
        }
    }
    //console.log('decodedCookie = '+decodedCookie);
    if (!letterCheck){
        var letterCount = 0;
        var resultPbDdBreed = resultString.resultPbDdBreed;
        if (resultPbDdBreed !== undefined && resultPbDdBreed !== null && resultPbDdBreed.length > 0) {
            letterCount = letterCount + 1;
        }
        if (resultString.event[0] !== null && resultString.event[0] !== undefined &&
            resultString.event[0]['letterflag'] != null && resultString.event[0]['letterflag'] != 'undefined') {
            letterCount = letterCount + 1;
        }
        notifyCount = letterCount;
        document.cookie = "letterCheck=true";
    }

    if (!genHealthCheck){
        genHealthCount = $scope.atRiskData.length + $scope.carrierData.length;
        document.cookie = "genHealthCheck=true";
    }
    
    /*
     * Passing dummy date to match the objectPath for fetching service model reports form s3 bucket
     *  
     * */
    
    var base64EncodedToken = window.btoa('03102017\\'+$scope.sampleID+'\\'+$scope.sampleID+'-wo').replaceAll('=', '');
    
    $scope.downloadReportUrl = reportdata.pdfdownloadurl+'/'+base64EncodedToken+'.pdf';

    $scope.notifyCount = notifyCount;
    $scope.genHealthCount = genHealthCount;

    $rootScope.$broadcast('checkGenHealthCount', 0);

    NavigationService.setNavigationUrls();

    $scope.$on('checkGenHealthCount', function(event, actualValue) {
        $scope.genHealthCount = $scope.genHealthCount - actualValue;
    });

    $scope.$on('checkNotifyCount', function(event, actualValue) {
        $scope.notifyCount = $scope.notifyCount - actualValue;
    });

    ImageService.getImageUrl('4gvF3KnZfqOUoYMQWCcwka').then(function(response) {
        $scope.fbIcon = response.data.fields.file.url;
    });
    ImageService.getImageUrl('5GJEkOWWR2wu4e8COuWiQE').then(function(response) {
        $scope.twIcon = response.data.fields.file.url;
    });
    ImageService.getImageUrl('4dhYsZ1sqco0iqiUcsYC6I').then(function(response) {
        $scope.youtubeIcon = response.data.fields.file.url;
    });

    ImageService.getImageUrl('6lKwO09ax2a0QmWSQ4ocKk').then(function(response) {
        $scope.igIcon = response.data.fields.file.url;
    });

    ImageService.getImageUrl('2OK1sW2blScw0UG2kgiWAo').then(function(response) {
        $scope.marsVetLogo = response.data.fields.file.url;
    });
    ImageService.getImageUrl('32aMK5VSfKCE08C4oSUyOQ').then(function(response) {
        $scope.navForwardButton = response.data.fields.file.url;
    });
    ImageService.getImageUrl('1BcpcMv0FK6M0QG0Mg4QO').then(function(response) {
        $scope.navBackButton = response.data.fields.file.url;
    });
    ImageService.getImageUrl('4gEGHgNJbigiuok8aESeiq').then(function(response) {
        $scope.navNextButton = response.data.fields.file.url;
    });
    
    let serviceModelReports = ['AD','CG','DW','FG','GG'];
    let modelType = resultString.sampleID.substring(0, 2);
    let pdfReport = false;
    if(serviceModelReports.indexOf(modelType)>0){
    	pdfReport = true;
    }
    $scope.pdfReport = pdfReport;
    
    $scope.trackPdfDownload = function() {
        $window.ga('send', 'pageview', {
            'page': 'PdfDownload'
        });
    };
}

export default angular.module('mars.vet.dnareports.controllers.navbar', ["ng"]).controller('NavbarController', navbarController).name;



// WEBPACK FOOTER //
// ./client/apps/dnareport/controllers/navbar.controller.js